import React from 'react'

import List from './list'
import Form from './form'

import { Switch, Route, Redirect } from 'react-router-dom'

import { LAYOUT_REPORT_EXPORT_LIST, LAYOUT_REPORT_EXPORT_NEW } from '../navigation'

const Router = (props) => (
  <>
    <Switch>
      <Route path={LAYOUT_REPORT_EXPORT_LIST} render={(routeProps) => <List {...props} {...routeProps} />} />
      <Route path={LAYOUT_REPORT_EXPORT_NEW} render={(routeProps) => <Form alta {...props} {...routeProps} />} />
      <Redirect to={LAYOUT_REPORT_EXPORT_LIST} />
    </Switch>
  </>
)

export default Router
